var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwHeroDecoratorLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 183,
    viewBox: "0 0 744 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.6167L389.454 2.61674C408.701 2.61674 425.629 15.3441 430.975 33.8342V33.8342C436.32 52.3243 453.249 65.0517 472.496 65.0517L682.5 65.0517C715.085 65.0517 741.5 91.4669 741.5 124.052L741.5 179.552",
    stroke: "url(#paint0_linear_547_1099)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_547_1099",
    x1: 3,
    y1: 7.05176,
    x2: 746.306,
    y2: 176.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212205,
    stopColor: "#8A14FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525082,
    stopColor: "#DBC1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842205,
    stopColor: "#8A14FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwHeroDecoratorLine);
export default __webpack_public_path__ + "static/media/sw-hero-decorator-line.aa7a2cfaf86cf7ae6f42dbea4b60908a.svg";
export { ForwardRef as ReactComponent };